import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    minHeight: '80px',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    width: '70%',
    [theme.breakpoints.down('md')]: {
      width: '90%',
    },
  },
  acceptButton: {
    borderColor: theme.palette.common.white,
    color: theme.palette.common.white,
  },
  message: {
    color: theme.palette.common.white,
    paddingRight: theme.spacing(2),
  },
}));
